import { Component, OnDestroy, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReplaySubject, takeUntil } from 'rxjs';

import { LaunchDarklyFlags } from 'app/core/services/launch-darkly/launch-darkly.types';
import { getFeatureFlagObservable } from 'app/core/state';
import { RoomSizeInfo } from 'app/modules/social/types/room';
import SocialTheme from 'entity/SocialTheme';

@Component({
  selector: 'confirm-card',
  templateUrl: './confirm-card.component.html',
  styleUrls: ['./confirm-card.component.scss'],
  standalone: false,
})
export class ConfirmCardComponent implements OnDestroy, OnInit {
  private destroyed$ = new ReplaySubject<boolean>(1);

  @Input() public roomName?: string;
  @Input() public playlistId?: string;
  @Input() public theme?: SocialTheme;
  @Input() public roomSizeInfo?: RoomSizeInfo;
  @Input() public isCreateFlow = false;

  @Output() public createRoom = new EventEmitter<boolean>();

  protected itemEditor = false;

  public constructor(private store: Store) {}

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public ngOnInit(): void {
    getFeatureFlagObservable(this.store, LaunchDarklyFlags.item_editor)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((itemEditor) => (this.itemEditor = itemEditor));
  }

  public nextStep(): void {
    this.createRoom.emit(true);
  }

  public back(): void {
    this.createRoom.emit(false);
  }

  public createAndDecorate(): void {
    this.createRoom.emit(true);
  }
}
